function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') exports["cookie"] = factory();else root["XO"] = root["XO"] || {}, root["XO"]["cookie"] = factory();
})(this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};

      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/exports: {},
          /******/id: moduleId,
          /******/loaded: false
          /******/
        };

        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

        /******/ // Flag the module as loaded
        /******/
        module.loaded = true;

        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }

      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;

      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;

      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "";

      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(0);
      /******/
    }
    /************************************************************************/
    /******/([/* 0 */
    /***/function (module, exports, __webpack_require__) {
      exports.VERSION = "1.0.0";
      /**
      * @description Retrieve the value of a cookie.
      * @param {String} name Name of cookie value to retrieve
      * @returns {String} Value of the cookie specifed by the name parameter.
      * @public
      * @function
      */
      exports.getCookie = function getCookie(name) {
        var dc, l, i, j;
        dc = document.cookie;
        l = dc.length;
        if (l > 0) {
          i = dc.indexOf(name + '=');
          if (i !== -1) {
            i = i + name.length + 1;
            j = dc.indexOf(';', i);
            if (j === -1) {
              j = l;
            }
            return decodeURIComponent(dc.substring(i, j));
          }
        }
        return false;
      };

      /**
      * @description Set a cookie.
      * @param {String} name Name of the cookie to set.
      * @param {String} value Value of the cookie to be set.
      * @param {Integer} [expires="session"] Number of days for the cookie to be set.
      * @param {String} [path="Current directory"] Cookie path. Best to set to '/'.
      * @param {String} [domain="Current domain"] Cookie domain. Defaults to current domain/subdomain.
      * @returns {Boolean} TRUE if cookie was set.
      * @public
      * @function
      */
      exports.setCookie = function setCookie(name, value, expires, path, domain) {
        var expDate;
        // Must have a name.
        if (name) {
          // If non-falsy expires, (positive or negative) update date.
          if (expires) {
            expDate = new Date();
            expDate.setDate(expDate.getDate() + expires);
            expires = expDate.toUTCString();
          } else {
            expires = '';
          }
          // Set cookie.
          document.cookie = name + '=' + value + (expires ? ';expires=' + expires : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '');
          return true;
        }
        return false;
      };

      /**
      * @description Utility method for calling XO.cookie.setCookie().
      * @param {String} name Name of the cookie to delete.
      * @param {String} [path="Current directory"] Path of cookie to delete.
      * @param {String} [path="Current directory"] Domain of cookie to delete.
      * @returns {Boolean} TRUE if cookie was deleted.
      * @public
      * @function
      */
      exports.deleteCookie = function deleteCookie(name, path, domain) {
        domain = domain || '';
        isSuccessful = false;
        if (this.getCookie(name)) {
          if (domain === '') {
            isSuccessful = this.setCookie(name, '', -1000, path);
          } else {
            isSuccessful = this.setCookie(name, '', -1000, path, domain);
          }
        }
        return isSuccessful;
      }.bind(exports);

      /***/
    }
    /******/])
  );
});

;